// Shared, app-wide constants.

// ATSG's main customer-service phone number. Used across membership,
// payment, and contact copy — keep this as the single source of truth.
export const COMPANY_PHONE = '(800) 245-7722'
